export const environment = {
  production: true,
  staging: false,
  development: false,
  urlproduction: true,
  uapURL : '/',
  mediaURL: '/',
  mockApiURL :'/',
  baseURL: '/',
  miaugeoURL:  '/gosg/',
  autocompleteURL:  '',
  uapStgRegistrationURL: 'https://uap.malaysia.gov.my/uap/validatesigncryption.jsp?language=',
  uapStgProfileURL: 'https://uap.malaysia.gov.my/myprofile/update/updatechannel.jsp?tag=',
  uapStgChgPass: 'https://uap.malaysia.gov.my/uap/lostcredential.jsp?language=',
  uapProdRegistrationURL: 'https://uap.malaysia.gov.my/uap/validatesigncryption.jsp?language=',
  uapProdProfileURL: 'https://uap.malaysia.gov.my/myprofile/update/updatechannel.jsp?tag=',
  uapProdChgPass: 'https://uap.malaysia.gov.my/myprofile/change/password.jsp?language=',
  infoTrafficURL: 'https://www.malaysia.gov.my/',
  GAtrackingIdDev: 'UA-117768039-1',
  GAtrackingIdStg: 'UA-131574297-1',
  GAtrackingIdProd: 'UA-91357572-1'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts